<template>
  <div class="hello">
    <div class="bg">

      <div class="footer">
        <div class="leftNav">
          <div class="title">
            <!-- <span>{{exhibitionTitle}}</span> -->
            <span>{{this.$t('language.zhanting')}}</span>
          </div>
          <div class="line"></div>
          <div class="hallList">
            <div class="listW" :class="{listA:item.isActive}" v-for="(item,index) in tablist" :key="index" @click="hallList(item.id,index)">
              <span style="margin-right: 48px;">{{item.title}}</span>
            </div>
          </div>
        </div>

        <div class="right" @scroll="getscroll($event)" ref="righ">
          <!-- 没有数据 -->
          <div class="error" v-if="no && lang == 'cn'">
            <img src="../../assets/image/zanwucai.png" alt="">
          </div>
          <div class="error" v-if="no && lang == 'en'">
            <img src="../../assets/image/zanwucaiE.png" alt="">
          </div>
          <tr class="step-jump">
            <!--  <div class="gezhan" v-if="goji" id="box">
                 个展
              </div>
              <div class="gezhan" v-if="goji" id="box1">
                策展
              </div> -->
            <div class="gezhan" v-if="goji" :class="{iszhan:item.isActive}" v-for="(item,index) in gezhanlist" @click="gezhanEent(item.id,index)">
              {{item.name}}
            </div>

          </tr>
          <div class="contentList">
            <div class="zhanlist" v-for="(it,index) in showwz" :key="index" @click="zhanDetail(it.photographer_id,it)">
              <div class="zhantop" v-if="it.is_ad & it.file_type == 'video'">
                <video ref="video" style="width: 100%;height: 100%;" :src="it.cover_img_src" controls=""></video>
              </div>
              <div class="zhantop" v-else>
                <img :src="it.cover_img_src" alt="">
                <div class="mak"></div>
              </div>
              <div class="zhanbottom">
                <p :class="{ismar:it.organization_name != ''}" style="margin-top:17px;font-size: 16px;font-weight: 400;">{{it.display_name}}</p>
                <p v-if="it.organization_name!= ''" style="font-size: 14px;opacity: 0.8;">{{it.organization_name}}</p>
                <p style="font-size: 14px;opacity: 0.8;">{{it.name}}</p>
              </div>
            </div>
            <div class="clear"></div>
            <div style="height: 20px;"></div>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 35px;" v-if="error & !no">
            <img v-if="lang == 'cn'" src="../../assets/image/error.png" alt="">
            <img v-else src="../../assets/image/errorEn.png" alt="">
          </div>

          <div style="height: 80px;"></div>
          <fiex :shows="fixed" :fatherMethod="goTop">

          </fiex>
        </div>

      </div>
    </div>

    <div class="photographer" ref="photo" @scroll="getS" v-if="photographerShow">
      <div class="closeE" @click="closeBtn">
        <img src="../../assets/image/closeone.png" alt="">
      </div>
      <div class="photoNav">
        <div class="righ">
          <div class="left">
            <img :src="details.cover_img_src" alt="">
          </div>
          <div class="righT">
            <p>{{organization_name}}</p>
            <div class="width-H" v-html="details.summary">

            </div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div class="center_detail">
        <div class="imageL" v-for="(item,index) in userLists" :key="index" @click="userListDetail(item)">
          <div class="imageTop">
            <img :src="item.cover_img_src" alt="">
          </div>
          <div class="title_imag">
            {{item.name}}
          </div>
        </div>

      </div>
      <div class="clear"></div>
      <div class="img" v-if="photoError">
        <img v-if="lang=='cn'" src="../../assets/image/error.png" alt="">
        <img v-else src="../../assets/image/errorEn.png" alt="">
      </div>
      <!-- 底部悬浮按钮 -->
      <fiex :shows="detailS" :fatherMethod="goT"></fiex>
    </div>




    <!-- 摄影师详情 -->
    <div class="swiper_mask" v-if="swiperMsShow">
      <div class="swipers">
        <div class="swiperView">
          <div class="close" @click="closeEvent">
            <img src="../../assets/image/closeone.png" alt="">
          </div>
          <div class="swiper_view" ref="swiper_view">
            <video style="position: absolute;left: 0;right: 0;bottom: 0;top: 0;margin: auto; display: block;height: 100%;width: 100%;" 
              ref="videoPlay" :src="imageUrl" v-if="file_type == 'video'"  controls="controls" @contextmenu="contextmenu" ></video>
            <img :src="imageUrl" v-if="imageShow  & voteType == true & file_type == 'image'" ref="right" :style="{height:width}" alt="">
            <!-- <div class="bgclass" v-if="imageShow & voteType == true" :style="{background:'url('+ imageUrl +')'}"></div> -->
            <div class="jianjieList" v-if="imageShow  == false" :style="{background:'url('+ detailImage +')',backgroundSize:'cover'}">
              <div class="headerImage">
                <img style="width: 100%;height: 100%;" :src="cover_img_src == '' ? defaultImg : cover_img_src" alt="">
              </div>
              <div class="userName">
                <span>{{$t('language.photoUser')}} : {{userName}}</span>
              </div>
              <!-- <div class="works">
                <span></span>
              </div> -->
              <div class="worlsContent" style="color: #FFFFFF;" v-html="country">

              </div>
              <div class="bottom_btn">
                <div class="queren" @click="closeE">
                  <span>{{this.$t('language.ok')}}</span>
                </div>
                <div class="herfList" v-if="shop_link != ''">
                  <a :href="shop_link" style="text-decoration: none;color: #FFFFFF;" target="_blank">
                    <img class="imglis" src="../../assets/image/goshop.png" alt="">
                    <span>{{$t('language.buy')}}</span>
                  </a>
                </div>
              </div>


            </div>
          </div>
          <!-- <div class="dataList" @click="dataEvent">
            <span>摄影师简介</span>
          </div> -->
          <!-- <div class="herfList" v-if="shop_link != ''">
            <a :href="shop_link" style="text-decoration: none;color: #FFFFFF;" target="_blank">
              <span>跳转</span>
            </a>
          </div> -->
          <div class="swiper_leftBtn" :style="{background:'url('+ swiperLeftImg  +')',backgroundSize:'cover'}" @click="prevEvent"></div>
          <div class="swiper_rightBtn" :style="{background:'url('+ swiperRightImg +')',backgroundSize:'cover'}" @click="nextEvent"></div>
        </div>
        <div class="swiper_bottom_btn">
          <div class="dataList" @click="dataEvent" style="display: inline-block;width: 10%;float: left;height: 85px;line-height: 85px;margin-top:8px;padding:0 10px;font-size:14px;background:#151617;width: 7%;margin-right: 20px;">
            <div class="ima"><img src="../../assets/image/userjianjie.png" alt=""></div>
            <span>{{this.$t('language.photographerjianjie')}}</span>
          </div>
          <div style="display: inline-block;width: 90%;float: left;">
            <swiper class="swiper" style="width: 100%;" :options="swiperOptionO" ref="Swiper">
              <swiper-slide v-for="(item,index) in nextImage" :key="index" class="swiper-slides swiper-slide" >
                <div style="width: 112px;height: 96px;" :class="{isa:item.isActive}" @click="nextE(index,item.file_type)">
                  <img v-if="item.file_type == 'image'" :src="item.thumb_path" style="width: 112px;height: 96px;" alt="">
                  <video v-else style="width: 100%;height: 100%;" :src="item.file_path" ></video>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- <div class="swiper_btn" @mousedown.prevent="">
            <div class="prev_group" :class="{isa:item.isActive}" v-for="(item,index) in nextImage" :key="index" style="margin-left: 12px;"
              @click="nextE(index,item.file_type)">
              <img v-if="item.file_type == 'image'" :src="item.file_path" alt="">
              <video style="width: 100%;height: 100%;" v-else :src="item.file_path"></video>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import fiex from '../../components/fiex.vue'
  import BScroll from 'better-scroll'
  export default {
    components: {
      fiex
    },
    data() {

      return {
		  file_type:'video',
        swiperOptionO: {
          slidesPerView: 12,
          spaceBetween: 20,
          //设置点击箭头
          navigation: {
            nextEl: '.swiper_rightBtn',
            prevEl: '.swiper_leftBtn',
          },
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          //自动轮播
          loop: false,
        },
        defaultImg: require('../../assets/image/defaultHeader.png'),
        no: false,
        fixed: false,
        detailS: false,
        photographerShow: false,
        jianjieshow: false,
        bottom: 10,
        number: 3,
        goji: true,
        imageShow: false,
        country: '',
        title: '',
        it: 'e_img',
        swiperMsShow: false,
        activeStep: 0,
        width: '100%',
        imag: 'https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3892521478,1695688217&fm=26&gp=0.jpg',
        nextImages: 'https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1089874897,1268118658&fm=26&gp=0.jpg',
        index: 0,
        nextImage: [],
        swiperLeftImg: require('../../assets/image/swiper_left.png'),
        swiperRightImg: require('../../assets/image/swiper_right.png'),
        imageUrl: '', // 视图显示的图片
        showwz: [],
        exhibitionTitle: '',
        group: 12, // request param
        image: require('../../assets/image/banner1.png'),
        countpage: 1,
        arr: [],
        index: 0,
        userLists: [], // 多摄影师二级页面
        error: false,
        tablist: [],
        exhibition_category_id: 0,
        fenlei: false,
        details: {},
        organization_name: '',
        detailImage: require('../../assets/image/jianjie.png'),
        lang: 'cn',
        titleObj: {},
        userName: '',
        shop_link: '',
        photopage: 1,
        tabIndex: 0,
        voteType: true,
        photoError: false,
        tabs: [{
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },
          {
            img_src: 'https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2534506313,1688529724&fm=26&gp=0.jpg'
          },

        ],
        mX: 0,
        tabWidth: 300,
        cover_img_src: '',
        userId: 0, // 摄影师id
        exid: 1,
        click: 0
      }
    },
    destroyed() {
      this.page = 1;
    },
    computed: {
      gezhanlist() {
        var arr = [{
            name: this.$t('language.gezhan'),
            isActive: true,
            id: 1
          },
          {
            name: this.$t('language.cezhan'),
            isActive: false,
            id: 2
          }
        ];
        return arr;
      }
    },
    created() {
      if (localStorage.getItem('languageSet') == 'zh') {
        this.lang = 'en'
      } else {
        this.lang = 'cn'
      }
       if(this.organization_name == ''){
         if(this.$route.query.organization_name != ''){
           this.organization_name = this.$route.query.organization_name
         }else{
            this.organization_name = ''
         }
       }


      var that = this;
      this.title = this.$route.query.title;
      if (this.$route.query.display_category_id == 13 || this.$route.query.display_category_id == 14) {
        this.goji = true;
      } else {
        this.goji = false;
      }
      this.$fetch('/Hall/displayCategoryList').then(res => {
        var arr = [];

        this.tablist = res.data;
        // for (var i = 0; i < this.tablist.length; i++) {
        //   this.tablist[i].isActive = false;
        // }
        // this.tablist[this.tabIndex].isActive = true;
        // this.exhibitionTitle = this.tablist[0].name
        for (var i = 0; i < this.tablist.length; i++) {
          this.tablist[i].isActive = false;
          if (this.tablist[i].id == this.$route.query.display_category_id) {
            this.tablist[i].isActive = true;
          }
        }
        this.tablist[this.$route.query.index].isActive = true;
      })

      let query = this.$router.history.current.query;
      if (that.$route.query.exhibition_apply_id) {

        var data = {
          exhibition_apply_id: this.$route.query.exhibition_apply_id,
          page: 1,
        }
        this.$fetch('/Hall/photographerList', data).then(res => {
          this.userLists = res.data.list.data;
          this.details = res.data.detail;
        })
        that.photographerShow = true;
      } else {
        if (that.$route.query.exhibition_category_id) {
          for (var i = 0; i < that.tablist.length; i++) {
            console.log(that.tablist[i], 'sdawwadada')
            if (that.tablist[i].id == that.$route.query.exhibition_category_id) {
              this.tablist[i].isActive = true;
            } else {

              this.tablist[i].isActive = false;
            }
          }
          this.showwE(this.$route.query.photographer_id);
          if (this.$route.query.file_type == 'image') {
            this.voteType = true;
          } else {
            this.voteType = false;
          }


          this.ajaxFun(this.$route.query.display_category_id, this.$route.query.exhibition_category_id == 0 ? 1 : this.$route
            .query.exhibition_category_id, 1)

        } else {
          this.swiperMsShow = false;
          this.ajaxFun(this.$route.query.display_category_id, 0, 1)
        }

      }
      // 判断 从首页 跳过来 是否是 国际 和 国内 展  是 要带第一个 个展的 id 否则  id 为0
      if (this.$route.query.display_category_id == 13 || this.$route.query.display_category_id == 14) {
        // 第二个参数 是 展览的id
        this.ajaxFun(this.$route.query.display_category_id, 1, 1)
      } else {
        this.ajaxFun(this.$route.query.display_category_id, 0, 1)
      }

    },
    mounted() {
      this.$nextTick(function() {
        this.$refs.righ.addEventListener('scroll', this.onScroll)
      })
		
		},
    methods: {
      contextmenu() {
        return false;
      },
      tabList(item) {
        console.log(item);

      },
      goT() {
        this.$refs.photo.scrollTop = 0;
      },
      getscroll(event) {
        let scrollBottom =
          event.target.scrollHeight -
          event.target.scrollTop -
          event.target.clientHeight;
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.righ.scrollTop ||
          window.pageYOffset;

        if (scrollTop > 20) {
          this.fixed = true;
        } else {
          this.fixed = false;
        }

        // 判断用户是在策展 还是个展
        let pageId = 0;
        if (this.exhibition_category_id == 13 || this.exhibition_category_id == 14 || this.$route.query.display_category_id ==
          13 || this.$route.query.display_category_id == 14) {
          pageId = this.exid;
        } else {
          pageId = 0;
        }
        if (scrollBottom <= 1) {

          this.countpage += 1
          var data = {
            display_category_id: this.exhibition_category_id == 0 ? this.$route.query.display_category_id : this.exhibition_category_id,
            exhibition_category_id: pageId,
            page: this.countpage,
          }
          var that = this;
          if (!this.error) {
            this.$post('/Hall/newList', data).then(res => {
              if (res.data.data.length <= 0) {
                this.error = true
              } else {
                this.error = false;


                res.data.data.forEach(item => {
                  this.showwz.push(item);
                })
              }
            })
          } else {}

        }

      },
      getS(event) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.photo.scrollTop ||
          window.pageYOffset;
        console.log(scrollTop)
        if (scrollTop > 20) {
          this.detailS = true;
        } else {
          this.detailS = false;
        }
        let scrollBottom =
          event.target.scrollHeight -
          event.target.scrollTop -
          event.target.clientHeight;
        console.log(scrollBottom);
        if (scrollBottom == 0) {
          this.photopage += 1;
          if (!this.photoError) {
            var data = {
              exhibition_apply_id: this.userId || this.$route.query.exhibition_apply_id,
              page: this.photopage,
            }
            this.$fetch('/Hall/photographerList', data).then(res => {
              if (res.data.list.data.length <= 0) {
                this.photoError = true;
              } else {
                this.photoError = false;

              }
              res.data.list.data.forEach(item => {
                this.userLists.push(item);
              })
            })
          }

        } else {
          return
        }


      },
      // 多摄影是详情
      userListDetail(item) {
        var data = {
          id: item.id
        }
        this.voteType = true;
        this.$fetch('/Hall/detail', data).then(res => {
          console.log(res);
          var arr = [];
          var show = true;
		  this.file_type = res.data[0].upload_work[0].file_type;
          res.data[0].upload_work.forEach(item => {
            var obj = {};
            if (item.file_type == 'video') {
              show = false;
            } else {
              show = true;
            }
            obj = item;
            obj.isActive = false;
            arr.push(obj);
            arr[0].isActive = true;
          })
		  console.log('2321312312312312')
          if (show) {
            this.imageUrl = res.data[0].upload_work[0].water_path;
          } else {
			
            this.imageUrl = res.data[0].upload_work[0].water_path;
          }
          this.country = res.data[0].summary;
          this.userName = res.data[0].name;
          this.shop_link = res.data[0].shop_link;
          this.cover_img_src = res.data[0].img_src;
          this.nextImage = arr;
          this.swiperMsShow = true;
        })
      },
      showwE(id) {
        var data = {
          id: id
        }
        this.$fetch('/Hall/detail', data).then(res => {
          console.log(res);
          var arr = [];
          res.data[0].upload_work.forEach(item => {
            var obj = {};
            obj = item;
            obj.isActive = false;
            arr.push(obj);
            arr[0].isActive = true;
          })
		
          this.imageUrl = res.data[0].upload_work[0].water_path;
          this.country = res.data[0].summary;
          this.userName = res.data[0].name;
          this.cover_img_src = res.data[0].img_src;
          this.nextImage = arr;
        })
        this.swiperMsShow = true;
      },
      closeBtn() {
        if (this.$route.query.type == 'home') {
          this.$router.push('/')
        } else {
          this.imageUrl = '';
          this.photographerShow = false;
          this.nextImage = [];
        }

      },
      ajaxFun(name, id, page) {
        console.log(id);
        var data = {
          display_category_id: name,
          page: page,
          exhibition_category_id: id
        }
        var that = this;

        this.$fetch('/Hall/newList', data).then(res => {
          console.log(res);
          var arr = [];
          console.log(res);
          if (res.data.data != 'undefined') {
            res.data.data.forEach(item => {
              var obj = {};
              obj = item;
              obj.isActive = false;
              arr.push(obj)
            })
            if (res.data.data.length <= 0) {
              this.no = true;
            } else {
              this.no = false;
              this.error = false;
            }
            that.showwz = res.data.data;
            that.titleObj = res.extra;
          }

        })
      },
      dataEvent() {
        this.imageShow = false;
        this.voteType = true;
      },
      closeE() {
        this.imageShow = true;
        this.voteType = true;
      },
      goTop() {
        this.$refs.righ.scrollTop = 0;
      },
      gezhanEent(id, index) {
        for (var i = 0; i < this.gezhanlist.length; i++) {
          this.gezhanlist[i].isActive = false;
        }
        this.gezhanlist[index].isActive = true;
        this.exid = id;
        this.error = false;
        this.showwz = [];
        var data = {
          display_category_id: this.exhibition_category_id == 0 ? this.$route.query.display_category_id : this.exhibition_category_id,
          exhibition_category_id: id,
          page: 1,
        }
        this.$post('/Hall/newList', data).then(res => {
          console.log(res.data.data);
          if (res.data.data.length <= 0) {
            this.no = true;
          } else {
            this.no = false;
            var arr = [];
            res.data.data.forEach(item => {
              if (item.photographer_type == 'single') {
                this.fenlei = false;
              } else {
                this.fenlei = true;
              }
              item.isActive = true;
              arr.push(item);
            })
            this.showwz = arr;
            if (res.data.data.length <= 0) {
              this.error = false;
            }
          }
          this.titleObj = res.extra
          // if(res.data.data == ''){
          //   this.$message.error('暂无数据')
          // }
        })
      },
      // 左侧切换
      hallList(id, index) {
        this.error = false;
        for (var i = 0; i < this.tablist.length; i++) {
          this.tablist[i].isActive = false;
        }
        this.tablist[index].isActive = true;
        this.tabIndex = index;
        let pageid = 0;
        if (id == 13 || id == 14) {
          this.goji = true;
          pageid = 1;
        } else {
          pageid = 0;
          this.goji = false;
        }
        this.exhibition_category_id = id;
        this.countpage = 1;
        // this.countpage = 1;

        this.showwz = [];

        var data = {
          display_category_id: id,
          exhibition_category_id: pageid,
          page: 1,
        }
        // this.ajaxFun(this.$route.query.display_category_id,id)
        this.$post('/Hall/newList', data).then(res => {
          console.log(res.data.data);
          if (res.data.data.length <= 0) {
            this.no = true;
          } else {
            this.no = false;
            var arr = [];
            res.data.data.forEach(item => {
              if (item.photographer_type == 'single') {
                this.fenlei = false;
              } else {
                this.fenlei = true;
              }
              item.isActive = true;
              arr.push(item);
            })
            this.showwz = arr;
            if (res.data.data.length <= 0) {
              this.error = false;
            }
          }
          this.titleObj = res.extra
          // if(res.data.data == ''){
          //   this.$message.error('暂无数据')
          // }
        })

      },
      nextE(index, type) {
		  this.file_type = type;
        if (type == 'video') {
          this.voteType = false;
          this.$nextTick(() => {
            this.$refs.videoPlay.load()
          })
        } else {
          this.voteType = true;
        }
        this.index = index;
        this.imageShow = true;
        
        for (var i = 0; i < this.nextImage.length; i++) {
          this.nextImage[i].isActive = false;
        }
        this.nextImage[this.index].isActive = true;
        if (this.voteType == false) {
          this.imageUrl = this.nextImage[this.index].water_path;
        } else {
          this.imageUrl = this.nextImage[this.index].water_path;
        }

        console.log(this.imageUrl);
      },
      // 上一张
      prevEvent() {
		  if (this.file_type == 'video') {
		    this.voteType = false;
		    this.$nextTick(() => {
		      this.$refs.videoPlay.load()
		    })
		  } else {
		    this.voteType = true;
		  }
		  this.imageUrl = this.nextImage[this.index].water_path
        this.imageShow = true;
        console.log(this.index)
        if (this.index != 0) {
          this.index--
        }
        for (var i = 0; i < this.nextImage.length; i++) {
          this.nextImage[i].isActive = false
        }
        this.nextImage[this.index].isActive = true;
		if(this.file_type == 'image'){
			this.imageUrl = this.nextImage[this.index].water_path
		}else{
			this.imageUrl = this.nextImage[this.index].file_path
		}
      },
      // 下一张
      nextEvent() {
		  if (this.file_type == 'video') {
		    this.voteType = false;
		    this.$nextTick(() => {
		      this.$refs.videoPlay.load()
		    })
		  } else {
		    this.voteType = true;
		  }
        this.imageShow = true;
        if (this.index >= this.nextImage.length - 1) {
          this.index = this.nextImage.length - 1
        } else {
          this.index++
        }
        for (var i = 0; i < this.nextImage.length; i++) {
          this.nextImage[i].isActive = false
        }
        this.nextImage[this.index].isActive = true;
       if(this.file_type == 'image'){
		    this.imageUrl = this.nextImage[this.index].water_path
	   }else{
		    this.imageUrl = this.nextImage[this.index].file_path
	   }
      },


      tabEvent(index) {
        for (var i = 0; i < this.tablist.length; i++) {
          this.tablist[i].isActive = false;
        }
        this.tablist[index].isActive = true;
      },

      zhanDetail(id, item) {
        if (item.is_ad) {
          if (item.link) {
            window.open(item.link);
          }
          return
        }
        this.userId = item.id;
        var that = this;
        if (item.photographer_type == 'single') {
          var data = {
            id: id
          }
          this.voteType = true;
          this.$fetch('/Hall/detail', data).then(res => {
            console.log(res);
            console.log(res.data[0].upload_work[0].file_type, 'aaaaaa')
            if (res.data[0].upload_work[0].file_type == 'image') {
				 this.file_type = 'image'
              this.voteType = true;
			 
            } else {
				this.file_type = 'video'
              this.voteType = false;
            }
            var arr = [];
            res.data[0].upload_work.forEach(item => {
              var obj = {};
              obj = item;
              obj.isActive = false;
              arr.push(obj);
              arr[0].isActive = true;
            })

            this.imageUrl = res.data[0].upload_work[0].water_path;
            this.nextImage = arr;
            this.country = res.data[0].summary;
            this.userName = res.data[0].name;
            this.shop_link = res.data[0].shop_link;
            this.cover_img_src = res.data[0].img_src;


          })
          this.swiperMsShow = true;
        } else {
          this.organization_name = item.organization_name;
          var data = {
            exhibition_apply_id: item.id,
            page: 1,
          }
          this.$fetch('/Hall/photographerList', data).then(res => {
            this.userLists = res.data.list.data;
            this.details = res.data.detail;
          })
          this.photographerShow = true;

        }

      },
      closeEvent() {
        // 如果从首页
        if (this.$route.query.type && this.$route.query.type == 'home') {
          this.$router.push({
            path: '/'
          })
        } else {
          this.imageUrl = ""
          this.imageShow = false;
          this.swiperMsShow = false
        }


      },
      adsw(e) {
        console.log('123')
      },

      over(index) {
        console.log(index)
        for (var i = 0; i < this.showwz.length; i++) {
          this.showwz[i].isActive = false;
        }
        this.showwz[index].isActive = true
      },
      out(index) {
        for (var i = 0; i < this.showwz.length; i++) {
          this.showwz[i].isActive = false;
        }
        this.showwz[index].isActive = false
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../../assets/css/detail/halldetail.css");

  .ismar {
    margin-top: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/detail/halldetail.vue